const sectionViewObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      entry.target.classList.toggle('section-view', entry.isIntersecting);
    });
  },
  { rootMargin: '0px 0px -5% 0px', threshold: 0.15 },
);

function observeSection(section) {
  if (!section?.classList?.contains('shopify-section')) return;
  sectionViewObserver.observe(section);
}

function initSectionView() {
  document.querySelectorAll('[id^="shopify-section-"]').forEach(observeSection);
}

initSectionView();

document.addEventListener('shopify:section:load', (event) => {
  observeSection(event.target);
});

document.addEventListener('shopify:section:unload', (event) => {
  if (event.target?.classList?.contains('shopify-section')) {
    sectionViewObserver.unobserve(event.target);
    event.target.classList.remove('section-view');
  }
});

